import styled from "styled-components";

export const StyledCashFlowWrapper = styled.div`
  .tab-body {
    @media screen and (max-width: 992px) {
      padding: 0;
      border: none;
      border-radius: 0;
      box-shadow: none;
    }
  }

  .content-head {
    padding: 15px 0 25px;
    display: grid;
    align-items: center;
    grid-template-columns: max-content 175px;
    grid-gap: 20px;
    @media screen and (max-width: 576px) {
      grid-template-columns: 100%;
    }
  }

  .cash-flow-balance-head {
    grid-template-columns: max-content 175px 1fr;
    grid-gap: 20px;
    .balance-notification-wrapper {
      display: inline-grid;
      align-items: center;
      justify-content: end;
      grid-template-rows: 45px;      
      button {
        height: 100%;
      }
    }
    @media screen and (max-width: 768px) {
      grid-template-columns: 100%;
      .balance-notification-wrapper {
        justify-content: start;
      }
    }
  }
  
`;